import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Particle from "../Particle";
import { Helmet } from "react-helmet-async";
import {
  AiOutlineMail,
  AiOutlineEnvironment,
} from "react-icons/ai";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  function handleChange(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  function handleSubmit(e) {
    e.preventDefault();
    const { name, email, message } = formData;
    const mailto = `mailto:cosmin.pascariu.cp@gmail.com?subject=Portfolio contact from ${encodeURIComponent(name)}&body=${encodeURIComponent(`From: ${name} (${email})\n\n${message}`)}`;
    window.open(mailto, "_blank");
    setSubmitted(true);
  }

  return (
    <>
      <Helmet>
        <title>Contact — Cosmin Pascariu</title>
        <meta
          name="description"
          content="Get in touch with Cosmin Pascariu — front-end and mobile developer based in Romania. Available for freelance and collaboration."
        />
        <link rel="canonical" href="https://cosminpascariu.com/contact" />
        <meta
          name="robots"
          content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1"
        />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Cosmin Pascariu" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:title" content="Contact — Cosmin Pascariu" />
        <meta
          property="og:description"
          content="Get in touch — available for freelance and collaboration."
        />
        <meta property="og:url" content="https://cosminpascariu.com/contact" />
        <meta
          property="og:image"
          content="https://cosminpascariu.com/og/cosmin-1200x630.jpg"
        />
        <meta property="og:image:alt" content="Contact Cosmin Pascariu" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact — Cosmin Pascariu" />
        <meta
          name="twitter:description"
          content="Get in touch — available for freelance and collaboration."
        />
        <meta
          name="twitter:image"
          content="https://cosminpascariu.com/og/cosmin-1200x630.jpg"
        />

        <script type="application/ld+json">{`
  {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "url": "https://cosminpascariu.com/contact",
    "name": "Contact Cosmin Pascariu",
    "mainEntity": { "@id": "https://cosminpascariu.com/#me" },
    "isPartOf": { "@id": "https://cosminpascariu.com/#website" }
  }
  `}</script>

        <script type="application/ld+json">{`
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://cosminpascariu.com" },
      { "@type": "ListItem", "position": 2, "name": "Contact", "item": "https://cosminpascariu.com/contact" }
    ]
  }
  `}</script>
      </Helmet>

      <Container fluid className="contact-section">
        <Particle />
        <Container>
          <Row style={{ justifyContent: "center" }}>
            <Col md={8} lg={7}>
              <h1 className="project-heading" style={{ paddingBottom: "10px" }}>
                Get In <strong className="purple">Touch</strong>
              </h1>
              <p style={{ color: "rgba(255,255,255,0.75)", textAlign: "center", paddingBottom: "15px" }}>
                Have a project in mind, a freelance opportunity, or just want to
                say hi? Feel free to reach out.
              </p>

              <div className="contact-details-row">
                <div className="contact-detail">
                  <AiOutlineMail className="purple" style={{ fontSize: "1.2em", flexShrink: 0 }} />
                  <a
                    href="mailto:cosmin.pascariu.cp@gmail.com"
                    style={{ color: "white", marginLeft: "8px" }}
                  >
                    cosmin.pascariu.cp@gmail.com
                  </a>
                </div>
                <div className="contact-detail">
                  <AiOutlineEnvironment className="purple" style={{ fontSize: "1.2em", flexShrink: 0 }} />
                  <span style={{ color: "white", marginLeft: "8px" }}>
                    Romania — Available Remote
                  </span>
                </div>
              </div>

              <div className="contact-card">
                {submitted ? (
                  <div style={{ color: "white", textAlign: "center", padding: "30px 0" }}>
                    <h2 className="purple">Thanks!</h2>
                    <p>Your email client should have opened. If not, email me directly at cosmin.pascariu.cp@gmail.com</p>
                  </div>
                ) : (
                  <Form onSubmit={handleSubmit} style={{ textAlign: "left" }}>
                    <Row>
                      <Col sm={6}>
                        <Form.Group className="mb-3" controlId="contactName">
                          <Form.Label className="contact-label">Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            placeholder="Your name"
                            required
                            value={formData.name}
                            onChange={handleChange}
                            className="contact-input"
                          />
                        </Form.Group>
                      </Col>
                      <Col sm={6}>
                        <Form.Group className="mb-3" controlId="contactEmail">
                          <Form.Label className="contact-label">Email</Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            placeholder="your@email.com"
                            required
                            value={formData.email}
                            onChange={handleChange}
                            className="contact-input"
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-4" controlId="contactMessage">
                      <Form.Label className="contact-label">Message</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={5}
                        name="message"
                        placeholder="How can I help you?"
                        required
                        value={formData.message}
                        onChange={handleChange}
                        className="contact-input"
                      />
                    </Form.Group>

                    <Button variant="primary" type="submit" className="contact-submit-btn">
                      Send Message
                    </Button>
                  </Form>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
}

export default Contact;
